import { struct } from 'io-ts/Decoder';

import { Values } from '../../../../user/skills/Values';

export const Request = struct({
	values: Values,
});
